module.exports = __webpack_public_path__ + "static/scale-model-of-national-harbor-in-alexandria-virginia-baf3b410e0c46992678fee3c936824d8.png";